import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ConditionsCreditContent from '../components/ConditionsCreditContent';
import SEO, { SEOPages } from '../components/SEO';

const ConditionsCredit = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-atom-dark pt-24 pb-16">
      <SEO {...SEOPages.conditionsCredit} />
      <div className="container mx-auto px-4">
        {/* Back button */}
        <div className="mb-8">
          <Link to="/demande-credit" className="inline-flex items-center text-gray-400 hover:text-white transition-colors">
            <ArrowLeft className="mr-2" size={20} />
            Retour au formulaire
          </Link>
        </div>

        {/* Content */}
        <div className="max-w-4xl mx-auto">
          <div className="glass p-8 md:p-12 rounded-2xl">
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-8">
              Mentions légales relatives aux demandes de crédit
            </h1>

            <ConditionsCreditContent />

            {/* Back button */}
            <div className="mt-12 pt-8 border-t border-gray-700">
              <Link
                to="/demande-credit"
                className="btn-glass btn-primary inline-flex items-center"
              >
                <ArrowLeft className="mr-2" size={18} />
                Retour au formulaire de demande
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConditionsCredit;